import React, { Component } from 'react'
import PlusIcon from '../icons/plusicon';
import { Link } from 'react-router-dom';
import FpgBeyondDetailView from './../component/fpg/view/FpgBeyondDetailView';
import FpgNfDetailView from './../component/fpg/view/FpgNfDetailView';
import FpgFilmDetailView from './../component/fpg/view/FpgFilmTabView';
import service from '../services'
import moment from 'moment'
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
import TalkEventListTable from '../component/fpg/list/TalkEventListTable';
import FpgFilmTab from '../component/fpg/list/FilmListTable';
import NewFrontierList from '../component/fpg/list/NewFrontierList';
import PartnerEventsView from '../component/fpg/view/PartnerEventsView';
import PartnerEventsList from '../component/fpg/list/PartnerEventsList';
import OtherEventsView from '../component/fpg/view/OtherEventsView';
import OtherEventsList from '../component/fpg/list/OtherEventsList';

const mapStateToProps = state => ({
    currentTab: state.currentTab,
    filmEditId: state.filmEditId,
    LiveSceeringEditId: state.LiveSceeringEditId,
    NewFrontierEditDataEditId: state.NewFrontierEditDataEditId,
    TalkEventEditDataEditId: state.TalkEventEditDataEditId,
    partnerEventId: state.partnerEventId,
    otherEventId: state.otherEventId
})
const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;
class FilmDetailView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activetab: '' || 0,
            data: [
                {
                    "label": "FILMS",
                    "Content": "This is content for Tab 1",
                    "tabIndex": 0,
                },
                {
                    "label": "EVENTS",
                    "Content": "This is content for Tab 2",
                    "tabIndex": 1,
                },
                {
                    "label": "SCREENINGS",
                    "Content": "This is content for the Screenings tab",
                    "tabIndex": 5,
                },
                {
                    "label": "NEW FRONTIER",
                    "Content": "This is content for Tab 3",
                    "tabIndex": 2,
                },
                {
                    "label": "PARTNER EVENTS",
                    "Content": "This is content for Tab 4",
                    "tabIndex": 3,
                },
                {
                    "label": "INSTITUTE EVENTS",
                    "Content": "This is content for Tab 5",
                    "tabIndex": 4,
                }
                // {
                //     "label":"LIVE SCREENING",
                //     "Content":"This is content for Tab 4",
                // }
            ]
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    componentDidMount() {
        var callFrom = this.props.currentTab;

        if (callFrom) {
            this.setState({
                activetab: callFrom
            })
        }
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "film|getLastUpdated":
                    this.setState({
                        getLastUpdated: response.data
                    })
                    break;

                default:
                    break;
            }
        });
    }

    TabClick = (index) => {
        this.setState({
            activetab: index
        }, () => {
            if (index === 0) {
                this.props.filmEditData('')
                this.props.CurrentTab(0)
                this.props.history.push('/filmlist')
            }
            if (index === 1) {
                this.props.TalkEventEditData('')
                this.props.CurrentTab(1)
                this.props.history.push('/filmlist')
            }
            if (index === 2) {
                this.props.NewFrontierEditData('')
                this.props.CurrentTab(2)
                this.props.history.push('/filmlist')
            }
            if (index === 3) {
                this.props.PartnerEventsEditData('');
                this.props.CurrentTab(3)
                this.props.history.push('/filmlist')
                // this.props.LiveSceeringEditData('')
                // this.props.CurrentTab(3)
                // this.props.history.push('/filmlist')
            }
            if (index === 4) {
                this.props.OtherEventsEditData('');
                this.props.CurrentTab(4)
                this.props.history.push('/filmlist')

            }
            if (index === 5) {
                this.props.CurrentTab(5)
                this.props.history.push('/filmlist')
            }
        })
    }

    setLastUpdated = (data) => {
        this.setState({
            getLastUpdated: data
        })
    }

    AddPage = (index) => {
        if (index === 0) {
            this.props.filmEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 1) {
            this.props.TalkEventEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 2) {
            this.props.NewFrontierEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 3) {
            this.props.PartnerEventsEditData('');
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
            // this.props.LiveSceeringEditData('')
            // this.TabClick(index)
            // this.props.CurrentTab(index)
            // this.props.history.push('/create-film')
        }
        if (index === 4) {
            this.props.OtherEventsEditData('');
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
    }

    render() {
        const { getLastUpdated } = this.state
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy
        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list) => {
                                const index = list.tabIndex;
                                if(list.label !== 'NEW FRONTIER' && list.label !== 'PARTNER EVENTS'){
                                    return (
                                        <li className={this.state.activetab === index ? 'active' : ''}>
                                            <p>
                                                <div onClick={() => this.TabClick(index)}>{list.label}</div>
                                                {list.label !== 'SCREENINGS' &&
                                                    <span id={index} onClick={() => this.AddPage(index)}><PlusIcon /></span>
                                                }
                                            </p>
                                        </li>
                                    )
                                }
                            })
                        }
                    </ul>

                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <Link className="back_link" to='/filmlist'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
                        {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
                            <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                        }
                    </div>
                    {
                        this.props.filmEditId === undefined && this.state.activetab === 0 ?
                            <FpgFilmTab history={this.props.history} />
                            :
                            this.state.activetab === 0 ?
                                <FpgFilmDetailView history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {
                        this.props.TalkEventEditDataEditId === undefined && this.state.activetab === 1 ?
                            <TalkEventListTable history={this.props.history} />
                            : this.state.activetab === 1 ?
                                <FpgBeyondDetailView history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {
                        this.props.NewFrontierEditDataEditId === undefined && this.state.activetab === 2 ?
                            <NewFrontierList history={this.props.history} />
                            :
                            this.state.activetab === 2 ?
                                <FpgNfDetailView history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }

                    {
                        this.props.partnerEventId === undefined && this.state.activetab === 3 ?
                            <PartnerEventsList history={this.props.history} />
                            :
                            this.state.activetab === 3 ?
                                <PartnerEventsView history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {
                        this.props.otherEventId === undefined && this.state.activetab === 4 ?
                            <OtherEventsList history={this.props.history} />
                            :
                            this.state.activetab === 4 ?
                                <OtherEventsView history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {/* {
                            this.props.LiveSceeringEditId === undefined  && this.state.activetab === 3? 
                            <liveScreening history={this.props.history}/>
                            :
                            this.state.activetab === 3 ?
                            <LiveScreeningView history={this.props.history}/>
                            : ''
                        } */}

                </div>
            </React.Fragment>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FilmDetailView)